//
//
//
//
//
//
//
//
//
//
//
//
//

import kebabCase from 'lodash.kebabcase'
import blok from '~/mixins/blok'
export default {
  mixins: [blok],

  computed: {
    rows () {
      const rows = this.blok.rows

      for (const row of rows) {
        if (!row.title_size) {
          row.title_size = this.blok.rows_title_size
        }
        if (!row.prose_size) {
          row.prose_size = this.blok.rows_prose_size
        }
        if (!row.text_column_size) {
          row.text_column_size = this.blok.rows_text_column_size
        }
        if (!row.img_sizing) {
          row.img_sizing = this.blok.rows_img_sizing
        }
      }

      return rows
    },

    sectionClass () {
      const classes = []

      switch (this.blok.background) {
        case 'beige':
          classes.push('tw-bg-cream-50')
          break
        case 'light-blue':
          classes.push('tw-bg-blue-50')
          break
        case 'white':
        default:
          classes.push('tw-bg-white')
      }

      if (this.blok.vertical_margin_size !== 'small') {
        classes.push('sm:tw-py-32')
      }

      return classes
    },

    rowsContainerClass () {
      const classes = []

      switch (this.blok.rows_gap) {
        case 'regular':
          classes.push('tw-gap-40')
          break
        case 'small':
        default:
          classes.push('tw-gap-28')
          break
      }

      return classes
    },
  },

  methods: {
    rowComponent (pascalCaseName) {
      return this.getBlokComponentName(kebabCase(pascalCaseName))
    },

    flipped (index) {
      if (!this.blok.flip_even_rows) {
        return false
      }
      return index % 2 !== 0
    }
  }
}
